<template>
    <div v-if="visible" class="loader-container loading-animation" :class="{ 'full-page-loader': fullPageLoader }">
        <div :id="preloaderContainerId" class="preloader p-4" :class="{ 'always-show': alwaysShow }">
            <div :id="statusContainerId" class="status" :class="{ 'always-show': alwaysShow }">
                <div
                    v-if="typeof loadingText !== 'string' || !loadingText.length"
                    class="spinner"
                    :class="{ 'text-center': horizontalCentered }"
                >
                    <i class="mdi mdi-loading mdi-spin"></i>
                </div>
                <div v-else class="spinner has--loading-text">
                    <div class="spinner-inner" :class="{ 'text-center': horizontalCentered }">
                        <i class="mdi mdi-loading mdi-spin"></i>
                    </div>
                    <div class="spinner-text" v-html="loadingText"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            required: true,
        },
        fullPageLoader: {
            type: Boolean,
            required: false,
            default() {
                return false;
            },
        },
        alwaysShow: {
            type: Boolean,
            required: false,
            default() {
                return true;
            },
        },
        preloaderContainerId: {
            type: String,
            required: false,
            default() {
                return 'preloader';
            },
        },
        statusContainerId: {
            type: String,
            required: false,
            default() {
                return 'status';
            },
        },
        loadingText: {
            type: String,
            required: false,
            default() {
                return null;
            },
        },
        horizontalCentered: {
            type: Boolean,
            required: false,
            default() {
                return false;
            },
        },
    },
};
</script>
